"use strict";

var processInclude = require("./util");

$(document).ready(function () {
    processInclude(require("./search/search"));
    processInclude(require("./product/swatch"));
    processInclude(require("./components/showLess"));
    processInclude(require("./product/compare"));
});
